import { Component, Input, OnInit } from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {CourseCacheService} from "../../shared/course-cache.service";

@Component({
    selector: 'app-roster-download-grades',
    templateUrl: './download-grades.component.html',
    styleUrls: ['./download-grades.component.scss']
})
export class DownloadGradesComponent implements OnInit {
    constructor(private route: ActivatedRoute,
    public courseCacheService: CourseCacheService) {
    }

    termCode: string;
    crn: string;


    ngOnInit(): void {
        this.termCode = this.route.snapshot.paramMap.get('termCode');
        this.crn = this.route.snapshot.paramMap.get('crn');
        this.courseCacheService.setCache(this.termCode, this.crn);
    }
}
